export default "__VITE_ASSET__juApky9B__"